module.exports = __webpack_public_path__ + "static/media/Badge_PngMarquePrivilege_Cerave_disabled.615634d7.png";